module.exports = __webpack_public_path__ + "static/media/2.4754a46b.png";